import React, { useState } from "react";
import { Card, Col, Form, Row, Button } from '@themesberg/react-bootstrap';


export default () => {
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: ""
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const canSave =
    formValues.name.trim().length > 0 &&
    formValues.email.trim().length > 0 &&
    formValues.password.trim().length > 0 &&
    formValues.password === formValues.confirmPassword;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!canSave) {
      return;
    }
    // TODO: wire to backend registration update endpoint.
  };

  return (
    <>
      <Row className="justify-content-center">
        <Col xs={12} xl={8}>
          <Card border="light" className="shadow-sm">
            <Card.Body>
              <h4 className="mb-3">Registration details</h4>
              <p className="text-muted mb-4">
                Update your sign-up details below.
              </p>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Full name</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    name="name"
                    value={formValues.name}
                    placeholder="e.g. Jane Njeri"
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    required
                    type="email"
                    name="email"
                    value={formValues.email}
                    placeholder="you@example.com"
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    required
                    type="password"
                    name="password"
                    value={formValues.password}
                    placeholder="New password"
                    onChange={handleChange}
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label>Confirm password</Form.Label>
                  <Form.Control
                    required
                    type="password"
                    name="confirmPassword"
                    value={formValues.confirmPassword}
                    placeholder="Re-enter password"
                    onChange={handleChange}
                    isInvalid={formValues.confirmPassword.length > 0 && formValues.password !== formValues.confirmPassword}
                  />
                  <Form.Control.Feedback type="invalid">
                    Passwords do not match.
                  </Form.Control.Feedback>
                </Form.Group>
                <Button variant="primary" type="submit" disabled={!canSave}>
                  Save changes
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};
